import React, { useState } from 'react';

function PaymentsPage(){
    return(
    <div className="container mt-4">
      <h2><i className="bi bi-cash me-2"></i>Payments</h2>
      <div className="card mt-3">
        <div className="card-body">
          <div className="alert alert-success">
            <h5>Current Balance: $0.00</h5>
            <p className="mb-0">Next Payment Due: December 1, 2023</p>
          </div>
          <button className="btn btn-success">
            <i className="bi bi-credit-card me-2"></i>Make Payment
          </button>
        </div>
      </div>
    </div>
  );

}

export default PaymentsPage;